import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import RequisitionAction from '../../../../../../Store/Component/Requisition/RequisitionAction'
import Growth from "./Growth";
import { CONSTANTS } from "client/utils/constants";
import { formatPrice } from 'utils'
import RequisitionValidation from "../../RequisitionValidation"
import { getEmployeeInfo, setEmployeeIDError, setEmployeeReasonInfo } from "Store/OrderManagement/EmployeeInfo/EmployeeInfoAction";

const GrowthContainer = (props: any) => {

  const reasonGrowth = props.reason;
  const requestType =props.requestType;
 
  const [employeeId, setEmployeeId] = useState('');
  const [salesAmount, setSalesAmount] = useState('');
  const [employeeName, setEmployeeName] = useState('');
  const [val, setVal] = useState<any>();
  const [isOnBlur, setIsOnBlur] = useState<any>(true);
  //dispatch
  const dispatch = useDispatch();

  //selectors
  const { reasonList, employeeInfo }: any = useSelector((state?: any) => ({
    reasonList: state.RequisitionReducer.reasonList,
    employeeInfo: state.EmployeeInfoReducer
  }));

  const employeeBusiness = [
    { value: 'Select New Employee/Business', label: 'Select New Employee/Business' },
    { value: CONSTANTS.NEW_EMPLOYEE, label: CONSTANTS.NEW_EMPLOYEE, text: CONSTANTS.NEW_EMPLOYEE },
    { value: CONSTANTS.NEW_BUSINESS, label: CONSTANTS.NEW_BUSINESS, text: CONSTANTS.NEW_BUSINESS }
  ];

  useEffect(() => {
    const reasonListTemp = reasonList?.length > 0 ? JSON.parse(JSON.stringify(reasonList)) : [];
    for (let i = 0; i < reasonListTemp.length; i++) {
      if (reasonListTemp[i]?.reasonIndex === employeeInfo?.employeeReasonInfo?.reasonIndex) {
        if( reasonListTemp[i]?.jobIdOrEmpId && reasonListTemp[i]?.newEmployeeBusiness != CONSTANTS?.NEW_BUSINESS){
        reasonListTemp[i].jobOrEmpName = employeeInfo?.employeeInfo?.employeeName ?? "";
        let responseReason = RequisitionValidation.ValidateReason({...reasonListTemp[i]});
        responseReason.jobIdOrEmpIdError = employeeInfo?.employeeInfoError;
        reasonListTemp[i] = responseReason;
        }
      }
    }
    dispatch(RequisitionAction.setIReason(reasonListTemp));
  },[employeeInfo?.employeeInfo, employeeInfo?.employeeInfoError]) 

  useEffect(() => {
    let timeOutId: any;
    if (employeeId) {
      timeOutId = setTimeout(() => props.plannedRef.current[11]?.focus()
        , 1300);
    }
    return () => clearTimeout(timeOutId);
  }, [employeeId])

  useEffect(() => {
    let timeOutId: any;
    if (employeeName) {
      timeOutId = setTimeout(() => props.plannedRef.current[12]?.focus()
        , 1300);
    }
    return () => clearTimeout(timeOutId);
  }, [employeeName])

  useEffect(() => {
    if (salesAmount) {
      let timeOutId: any;
      if (salesAmount) {
        timeOutId = setTimeout(() => props.plannedRef.current[13]?.focus()
          , 1300);
      }
      return () => clearTimeout(timeOutId);
    }
  }, [salesAmount])

  useEffect(() => {
    if (salesAmount) {
      let timeOutId: any;
      if (salesAmount) {
        timeOutId = setTimeout(() => props.plannedRef.current[13]?.focus()
          , 1300);
      }
      return () => clearTimeout(timeOutId);
    }
  }, [salesAmount])

  // onChange functions
  const onClickGrowthNewEmployeeOrBusiness = (item: any, reason: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true));
   
    let reasonListTemp = reasonList?.length > 0 ? JSON.parse(JSON.stringify(reasonList)) : [];
    
    for (let i = 0; i < reasonListTemp.length; i++) {
      if (reasonListTemp[i]?.reasonIndex === reason?.reasonIndex) {
        reasonListTemp[i].newEmployeeBusiness = item.value;
       

        reasonListTemp[i].jobIdOrEmpId = "";
        reasonListTemp[i].jobOrEmpName = "";
        reasonListTemp[i].salesAmount = "";
        reasonListTemp[i].jobIdOrEmpIdError = "";
        reasonListTemp[i].jobOrEmpNameError = "";
        reasonListTemp[i].salesAmountError = "";

        
        dispatch(setEmployeeReasonInfo(reason))
        let responseReason = RequisitionValidation.ValidateReason({...reasonListTemp[i]});
        reasonListTemp[i] = responseReason;
      }
    }
    dispatch(RequisitionAction.setIReason(reasonListTemp))
    if (item.label !== 'Select New Employee/Business') {
      props.plannedRef.current[10]?.focus()
    }
  }

  const onChangeNewEmployee = (e: any, item: any, reason: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true));
    let reasonListTemp = reasonList?.length > 0 ? JSON.parse(JSON.stringify(reasonList)) : [];
    for (let i = 0; i < reasonListTemp.length; i++) {
      if (reasonListTemp[i]?.reasonIndex === reason?.reasonIndex) {
          reasonListTemp[i].showNewEmployee = item
          reasonListTemp[i].jobOrEmpName = ""
          reasonListTemp[i].jobIdOrEmpId = ""
          reasonListTemp[i].jobIdOrEmpIdError = ""
          dispatch(setEmployeeReasonInfo(reason))
        const responseReason = RequisitionValidation.ValidateReason({...reasonListTemp[i]});
        reasonListTemp[i] = responseReason;
      }
    }
    dispatch(RequisitionAction.setIReason(reasonListTemp))
  }

  const onClickValidateEmployeeInfo = (_reasonType: any, _reason : any) => {
    if(_reason?.jobIdOrEmpId){
      dispatch(getEmployeeInfo({id:_reason?.jobIdOrEmpId, reasonIndex: _reason?.reasonIndex}))
      dispatch(setEmployeeReasonInfo(_reason))
    }else{
      const reasonListTemp = reasonList?.length > 0 ? JSON.parse(JSON.stringify(reasonList)) : [];
      for (let i = 0; i < reasonListTemp.length; i++) {
        if (reasonListTemp[i]?.reasonIndex === _reason.reasonIndex) {
        let responseReason = RequisitionValidation.ValidateReason({...reasonListTemp[i]});
        reasonListTemp[i] = responseReason;
        dispatch(RequisitionAction.setIReason(reasonListTemp));
        }
      }
    }
  }

  const onClickGrowthEmployeeId = (e: any, item: any, reason: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true));
    dispatch(setEmployeeIDError(""))
    let valTemp = ({...reason, jobIdOrEmpId :item.target.value, jobIdOrEmpIdError: ""})
        let responseReason = RequisitionValidation.ValidateReason({...valTemp});
        setVal(responseReason)
        setIsOnBlur(false);
    if (item) {
      setEmployeeId(item)
    }
  }

  const onClickGrowthEmployeeName = (e: any, item: any, reason: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true));
    let valTemp = ({...reason, jobOrEmpName :item.target.value})
        let responseReason = RequisitionValidation.ValidateReason({...valTemp});
        setVal(responseReason)
        setIsOnBlur(false);
    setEmployeeName(item);
  }

  const onClickGrowthSalesAmount = (e: any, item: any, reason: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true));
    const onChangVal = item.target.value
          const regEx = /^[\d\.?\d,\b]*$/; 
          const valArr = onChangVal.split('.')
          const checkNumber = regEx.test(onChangVal);
          if (!checkNumber || valArr.length > 2) { 
            return; 
          } 
          else {
            let valTemp = ({...reason, salesAmount :item.target.value})
            let responseReason = RequisitionValidation.ValidateReason({...valTemp});
            setVal(responseReason)
          }
    setIsOnBlur(false);
     
        dispatch(setEmployeeReasonInfo(reason))
      setSalesAmount(item)
  }

  const salesAmountFormat = (event: any, reason: any) => {
    reason.salesAmount = formatPrice(event.target.value, 2);
    setIsOnBlur(true)
    let reasonListTemp = reasonList?.length > 0 ? JSON.parse(JSON.stringify(reasonList)) : [];
    if (reason?.salesAmount !== "") {
      for (let i = 0; i < reasonListTemp.length; i++) {
        if (reasonListTemp[i]?.reasonIndex === reason?.reasonIndex) {
          reasonListTemp[i] = reason
         
          dispatch(setEmployeeReasonInfo(reason))
          let responseReason = RequisitionValidation.ValidateReason({...reasonListTemp[i]});
          reasonListTemp[i] = responseReason;
        }
      }
    }
    dispatch(RequisitionAction.setIReason(reasonListTemp))
  };

  const onClickGrowthComments = (e: any, item: any, reason: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true));
    let valTemp = ({...reason, comments :item.target.value})
        let responseReason = RequisitionValidation.ValidateReason({...valTemp});
        setVal(responseReason)
        setIsOnBlur(false);
 
        dispatch(setEmployeeReasonInfo(reason))
  }

  const numberMobile = (e:any) => {
    e.target.value = e.target.value.replace(/[^\d.]|\.(?=.*\.)/g, "");    
    return false;
  }
  const setEmployeeFieldDisable = (reason: any) => {
    if((requestType === CONSTANTS.MANAGED_EQUIPMENT || 
      requestType === CONSTANTS.MANAGEMENT_VEHICLE || 
      (requestType === CONSTANTS.NON_STANDARD_EQUIPMENT && reason?.newEmployeeBusiness === 'New Employee'))){
        if(reason?.showNewEmployee){
          return true
        }
    }
    return false
  }

  const OnBlurOfFields = (reason?: any) => {
    let reasonListTemp = reasonList?.length > 0 ? JSON.parse(JSON.stringify(reasonList)) : [];
    for (let i = 0; i < reasonListTemp.length; i++) {
      if (reasonListTemp[i]?.reasonIndex === reason?.reasonIndex) {
        reasonListTemp[i] = reason;
        let responseReason = RequisitionValidation.ValidateReason({...reasonListTemp[i]});
        reasonListTemp[i] = responseReason;
      }
    }
    setIsOnBlur(true)
    dispatch(RequisitionAction.setIReason(reasonListTemp));
  }

  return (<>
    <Growth
      employeeBusiness={employeeBusiness}
      reason={isOnBlur ? reasonGrowth : val}
      onClickGrowthNewEmployeeOrBusiness={onClickGrowthNewEmployeeOrBusiness}
      onClickGrowthEmployeeId={onClickGrowthEmployeeId}
      onClickGrowthEmployeeName={onClickGrowthEmployeeName}
      onClickGrowthSalesAmount={onClickGrowthSalesAmount}
      onClickGrowthComments={onClickGrowthComments}
      
      salesAmountFormat={salesAmountFormat}
      plannedRef={props.plannedRef}
      // salesAmount={salesAmount}
      numberMobile={numberMobile}
      requestType={requestType}
      onChangeQuotePrice={props.onChangeQuotePrice}
      onClickValidateEmployeeInfo={onClickValidateEmployeeInfo}
      onChangeNewEmployee={onChangeNewEmployee}
      employeeInfo={employeeInfo}
      reasonList={reasonList}
      setEmployeeFieldDisable = {setEmployeeFieldDisable}
      OnBlurOfFields = {OnBlurOfFields}
    />
  </>)
}

export default GrowthContainer;
